import type {
  TemplateConfigInput,
  TemplateType
} from '@server/trading-templates/schemas/input.schema';
import type { DraftFormState } from '@client/state/draft-form-state.hook';
import { formIndicatorsToTemplateValue } from './indicators-template-resolver';
import { formStrategyToTemplateValue } from './strategy-template-resolver';

export const buildTemplateConfig = (
  draftState: DraftFormState,
  templateType: TemplateType,
  timeframeIndex: number
): TemplateConfigInput => {
  if (!draftState) {
    throw new Error('Draft state is required');
  }

  switch (templateType) {
    case 'market':
      if (!draftState.marketConfig) {
        throw new Error('marketConfig must be preset in the "draftState"');
      }

      return { type: 'market', value: draftState.marketConfig };
    case 'indicators': {
      const indicators = draftState.timeframes?.[timeframeIndex].indicators;
      if (!indicators) {
        throw new Error('indicatorConfig must be preset in the "draftState"');
      }

      return {
        type: 'indicators',
        value: formIndicatorsToTemplateValue(indicators)
      };
    }
    case 'positionManagement':
      if (!draftState.positionManagementConfig) {
        throw new Error(
          'positionManagementConfig must be preset in the "draftState"'
        );
      }
      return {
        type: 'positionManagement',
        value: draftState.positionManagementConfig
      };
    case 'strategy': {
      const strategy = draftState.timeframes?.[timeframeIndex].strategy;

      if (!strategy) {
        throw new Error('strategy must be preset in the "draftState"');
      }

      return {
        type: 'strategy',
        value: formStrategyToTemplateValue(strategy)
      };
    }
    case 'signalBlock':
      throw new Error(
        'signalBlock templates are edited in Signal Block Builder and are not saved from trading form snapshot.'
      );
    default:
      throw new Error(`Unknown template type: ${templateType}`);
  }
};
